import Highlighter from 'react-highlight-words';
import cn from 'classnames';
import { useAppSelector } from 'hooks';
import { filtersSelector } from 'store/slices/mapV2/tabsReducer/layersReducer/stateSlice/selectors';

import { constructIdentifier } from 'utils';

import { EntityNode } from './types';

export const renderNodeName = (node: EntityNode) => {
  const { query, idQuery } = useAppSelector(filtersSelector);
  const searchWords = query ? [query] : idQuery ? [idQuery] : [];

  const constructText = (text: string, colorClassName: string) => (
    <span
      className={cn(
        'group-[.selected]:text-[inherit] group-hover:text-[inherit]',
        colorClassName
      )}
    >
      <Highlighter
        searchWords={searchWords}
        textToHighlight={text}
        highlightClassName="highlighted"
        unhighlightClassName="unhighlighted break-all"
        autoEscape={true}
      />
    </span>
  );

  return (
    <p className="flex flex-row gap-1">
      {!node.data.isFolder &&
        constructText(constructIdentifier(node.data.id), 'text-tpg_light')}
      {constructText(node.data.name, 'text-tpg_base')}
    </p>
  );
};
